import axios from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { IssuerIntegratorListResponse } from 'src/models/issuerIntegrator.models'
import { RootState } from 'src/redux/createRootReducer'
import { selectAuthedJsonApiRequestConfig } from 'src/redux/selectors/axios.selectors'

export const GET_ISSUERS_INIT = 'data/issuerIntegrators/GET_ISSUERS_INIT'
export const GET_ISSUERS_SUCCESS = 'data/issuerIntegrators/GET_ISSUERS_SUCCESS'
export const GET_ISSUERS_FAILURE = 'data/issuerIntegrators/GET_ISSUERS_FAILURE'

export interface GetIssuersSuccessPayload {
  issuers: IssuerIntegratorListResponse[]
}

export interface GetIssuersInitAction {
  type: typeof GET_ISSUERS_INIT
}
export interface GetIssuersSuccessAction {
  type: typeof GET_ISSUERS_SUCCESS
  payload: GetIssuersSuccessPayload
}
export interface GetIssuersFailureAction {
  type: typeof GET_ISSUERS_FAILURE
  payload: unknown
}

export type GetIssuersActions =
  | GetIssuersInitAction
  | GetIssuersSuccessAction
  | GetIssuersFailureAction

const createGetIssuersInitAction = (): GetIssuersInitAction => ({
  type: GET_ISSUERS_INIT,
})
const createGetIssuersSuccessAction = (
  payload: GetIssuersSuccessPayload,
): GetIssuersSuccessAction => ({
  type: GET_ISSUERS_SUCCESS,
  payload,
})
const createGetIssuersFailureAction = (
  err: unknown,
): GetIssuersFailureAction => ({
  type: GET_ISSUERS_FAILURE,
  payload: err,
})

export const getIssuers = (): ThunkAction<
  Promise<void>,
  RootState,
  void,
  GetIssuersActions
> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetIssuersActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createGetIssuersInitAction())
    return axios
      .get(`/issuers`, selectAuthedJsonApiRequestConfig(getState()))
      .then(
        (response) => {
          dispatch(createGetIssuersSuccessAction(response.data))
        },
        (err) => {
          dispatch(createGetIssuersFailureAction(err.response.data))
        },
      )
  }
}

export const GET_ISSUER_INIT = 'data/issuerIntegrators/GET_ISSUER_INIT'
export const GET_ISSUER_SUCCESS = 'data/issuerIntegrators/GET_ISSUER_SUCCESS'
export const GET_ISSUER_FAILURE = 'data/issuerIntegrators/GET_ISSUER_FAILURE'

export type GetIssuerSuccessPayload = IssuerIntegratorListResponse

export interface GetIssuerInitAction {
  type: typeof GET_ISSUER_INIT
}
export interface GetIssuerSuccessAction {
  type: typeof GET_ISSUER_SUCCESS
  payload: GetIssuerSuccessPayload
}
export interface GetIssuerFailureAction {
  type: typeof GET_ISSUER_FAILURE
  payload: unknown
}

export type GetIssuerActions =
  | GetIssuerInitAction
  | GetIssuerSuccessAction
  | GetIssuerFailureAction

const createGetIssuerInitAction = (): GetIssuerInitAction => ({
  type: GET_ISSUER_INIT,
})
const createGetIssuerSuccessAction = (
  payload: GetIssuerSuccessPayload,
): GetIssuerSuccessAction => ({
  type: GET_ISSUER_SUCCESS,
  payload,
})
const createGetIssuerFailureAction = (
  err: unknown,
): GetIssuerFailureAction => ({
  type: GET_ISSUER_FAILURE,
  payload: err,
})

export const getIssuer = (
  issuerId: string,
): ThunkAction<Promise<void>, RootState, void, GetIssuersActions> => {
  return async (
    dispatch: ThunkDispatch<RootState, void, GetIssuerActions>,
    getState: () => RootState,
  ): Promise<void> => {
    dispatch(createGetIssuerInitAction())
    return axios
      .get(`/issuers/${issuerId}`, selectAuthedJsonApiRequestConfig(getState()))
      .then(
        (response) => {
          dispatch(createGetIssuerSuccessAction(response.data))
        },
        (err) => {
          dispatch(createGetIssuerFailureAction(err.response.data))
        },
      )
  }
}
